export default __webpack_public_path__ + "static/media/ja_JP.11cbe24d.svg";